/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.TOUCHWIZ_INDEX = {

  '@GT': 
  [
     'GT-B5310!',
     'GT-B3410',
     'GT-B7722',
     'GT-C3262',
     'GT-C33(00|03)!',
     'GT-C3312R',
     'GT-C3312!',
     'GT-C3330',
     'GT-C6712',
     'GT-E2652!',
     'GT-I6230!',
     'GT-I6712!',
     'GT-M3710',
     'GT-M5650',
     'GT-S3370!',
     'GT-S36(50|53)!',
     'GT-S3770!',
     'GT-S38(00|02)!',
     'GT-S3850',
     'GT-S5220',
     'GT-S5222R',
     'GT-S5222',
     'GT-S52(30|33)!',
     'GT-S5260P',
     'GT-S52(60|63)!',
     'GT-S5292R',
     'GT-S5292',
     'GT-S5560!',
     'GT-S5600',
     'GT-S5603',
     'GT-S5620!',
     'GT-S5680',
     'GT-S7550',
     'GT-S8000c',
     'GT-S8003',
  ],
  '@S8': 
  [
     'S80(00|03)!',
  ],
  '@SG': 
  [
     'SGH-A597',
     'SGH-F480',
     'SGH-F480I',
     'SGH-T528g',
  ],
};

/* This file is automatically generated, do not edit manually! */
